import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { useStyles } from '../Integrations.styles';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IntegrationValues } from '~/Models/DTO/Integration.model';

interface IntegrationCardProps {
  title: string;
  buttonText: string;
  logo: string;
  description: string;
  link: string;
}

export const IntegrationCard = ({
  title,
  buttonText,
  logo,
  description,
  link,
}: IntegrationCardProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const buttonTextCheck =
    buttonText === t('integrations.edit.usc.connect') || buttonText === t('manage.integrations');

  return (
    <Link to={`${IntegrationValues.Integrations}/${link}`} className={classes.underlineNone}>
      <Card className={classes.card}>
        <img src={logo} alt={`${title} logo`} className={classes.logo} />
        <CardContent className={classes.content}>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body2" className={classes.integrationDescription}>
            {description}
          </Typography>
          <Link
            to={`${IntegrationValues.Integrations}/${link}`}
            className={buttonTextCheck ? classes.buttonResponsiveWhite : classes.buttonResponsive}
          >
            {buttonText}
          </Link>
        </CardContent>
        <Link
          to={`${IntegrationValues.Integrations}/${link}`}
          className={buttonTextCheck ? classes.buttonWhite : classes.button}
        >
          {buttonText}
        </Link>
      </Card>
    </Link>
  );
};
